import {Component, ViewEncapsulation} from '@angular/core';
import { OrderService } from './services/order.service';
import {ProductService} from "./services/product.service";
import {TypeService} from "./services/type.service";
import {PhotoService} from "./services/photo.service";
import {MenuService} from "./services/menu.service";
import {GeocodingService} from "./services/geocoding.service";
import {ClientService} from "./services/client.service";
import {StateService} from "./services/state.service";
import {AuthenticationService} from "./services/authentication.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./app.component.css',
              './../css/mdb.min.css',
              './../../node_modules/angular-bootstrap-md/scss/mdb.scss',
              './../../node_modules/ng2-toasty/style-bootstrap.css'],
  //template: '<h1>Ludo {{title}}</h1><div>{{order.id}}</div>',
  providers: [
      OrderService,
      ProductService,
      TypeService,
      PhotoService,
      MenuService,
      GeocodingService,
      ClientService,
      StateService,
      AuthenticationService
  ]
})

export class AppComponent {

    constructor(private authenticationService: AuthenticationService) {}

    logout() : void {
        this.authenticationService.logout();
    }

}



// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/app.component.ts